<template>
    <div>
        <button class="btn" ref="modal" v-show="false" data-toggle="modal" data-target="#messageModal"></button>
        <div class="modal fade" id="messageModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" @click.self="close">
            <div class="modal-dialog modal-c" role="document">
                <div class="modal-content">
                <div class="modal-header border-b-1">
                    <h4 class="modal-title" id="myModalLabel">{{message.title}}</h4>
                </div>
                <div class="modal-body modal-content-c">
                    <div class="mb-2" v-html="message.content"></div>
                    <div class="mb-1" v-for="(img, index) in message.images" >
                        <img :src="img.image_name" class="responsive-img" data-toggle="modal">
                        <br><span>圖片 {{index + 1}}</span>
                    </div>
                    <div class="mb-1"  v-for="(url, index) in message.link">
                        <span>連結{{index + 1}}： <a :href="url">{{url}}</a></span>
                    </div>
                    <small class="time">系統通知 ｜ {{message.update_time}}</small>
                </div>
                <div class="modal-footer" style="display: flex; justify-content: center;">
                    <button type="button" class="btn btn-default bt-c" data-dismiss="modal" @click="close">關閉</button>
                </div>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>

export default {
  name: 'NdAnnouncementOverlay',
  props: {
    dailogOpen: {
      type: Boolean,
      default: false
    },
    message: {
      type: Object,
      default: {}
    }
  },
  methods: {
    close () {
      this.$emit('update:close', this.message)
    }
  },
  watch: {
    dailogOpen (val) {
      if (val) {
        this.$refs.modal.click()
      }
    }
  }
}
</script>
<style lang="sass" scoped>
  .border-b-1
    border-bottom:  1px solid #e5e5e5
  .mb-1
    margin-bottom: 1em
  .mb-2
    margin-bottom: 2em
  .responsive-img
    height: auto;
    width: 100%;
</style>



// WEBPACK FOOTER //
// nd-announcement-overlay.vue?aa63c31c